require('./blocks/steps-info.less');
require('./blocks/tabs/tabs');
require('./blocks/info.less');
require('./blocks/help-block.less');
require('./blocks/reviews/reviews');
require('./blocks/review.less');



// WEBPACK FOOTER //
// ./payment_and_delivery.js